module.exports = {
          srcSet: __webpack_public_path__ + "5f9a7c385caa30313d209e9c4b555604-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "5f9a7c385caa30313d209e9c4b555604-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "5f9a7c385caa30313d209e9c4b555604-66.jpg",
          toString:function(){return __webpack_public_path__ + "5f9a7c385caa30313d209e9c4b555604-66.jpg"},
          
          width: 66,
          height: 66
        }